import { render, staticRenderFns } from "./CollectionsTable.vue?vue&type=template&id=585bfd2e&scoped=true&"
import script from "./CollectionsTable.vue?vue&type=script&lang=ts&"
export * from "./CollectionsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585bfd2e",
  null
  
)

export default component.exports